/**
 * Cookie helpers used to keep backwards compatibility with v1's
 * `ometricsID<masterKey>` cookie. The legacy backend reads that cookie
 * to correlate visitors across pageviews when localStorage is wiped.
 * Kept tiny on purpose - we don't bring in `js-cookie` because every
 * extra dep counts toward the 140KB budget.
 */
export function setCookie(name, value, days = 30) {
  if (typeof document === 'undefined') return
  const expires = new Date()
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000)
  const encoded = encodeURIComponent(value)
  document.cookie = `${name}=${encoded};expires=${expires.toUTCString()};path=/;SameSite=Lax`
}

export function getCookie(name) {
  if (typeof document === 'undefined') return ''
  const prefix = `${name}=`
  const parts = document.cookie ? document.cookie.split(';') : []
  for (const raw of parts) {
    const trimmed = raw.trim()
    if (trimmed.indexOf(prefix) === 0) {
      try {
        return decodeURIComponent(trimmed.substring(prefix.length))
      } catch {
        return trimmed.substring(prefix.length)
      }
    }
  }
  return ''
}
